import PropTypes from 'prop-types';

import classes from './DownloadFile.module.css';

const DownloadFile = ({ productData }) => {
  return (
    <div className={classes.section}>
      <aside className={classes.productIncludesContainer}>
        {productData.downloadFiles.map(item => (
          <a
            key={item.link}
            href={item.link}
            target="_blank"
            className={classes.productIncludesLink}
            rel="noreferrer"
          >
            <figure className={classes.productIcon}>
              <img className={classes.img} src={item.icon} alt="" />
            </figure>
            <span className={classes.productText}>{item.text}</span>
          </a>
        ))}
      </aside>
    </div>
  );
};

DownloadFile.propTypes = {
  // eslint-disable-next-line react/require-default-props
  productData: PropTypes.object
};

export default DownloadFile;
